<div class="p-grid p-nogutter">
    <ng-container *ngFor="let filter of filtersToShow; trackBy:keyValueTrackBy">
        <div class="p-col-{{columns}} p-nogutter al-aggregation-filter-content-righ-padding">
            <div class="al-aggregation-filter-content-label"
                   >{{ filter.key }}</div>
            <ng-container *ngIf="filter.values && filter.values.length">
                <div class="filter-value">
                    <div class="values" *ngFor="let value of filter.values; trackBy:stringTrackBy">
                        {{ value }}
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>

